import { Component, ComponentInterface, h, Host } from '@stencil/core';

@Component({
  tag: 'signet-table',
  styleUrl: 'signet-table.scss',
  shadow: false,
  scoped: false,
})
export class SignetTable implements ComponentInterface {
  render() {
    return (
      <Host>
        <div class="signet-table-container">
          <table class="signet-table">
            <slot></slot>
          </table>
        </div>
      </Host>
    );
  }
}
